import React, { useState } from "react";
import StreakPopup1 from "../assets/images/scanpoint/Popup-1.png";
import StreakPopup2 from "../assets/images/scanpoint/Popup-2.png";

function StreakHowToPopup({ onClose }) {
  const [step, setStep] = useState(1);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div style={{ position: "relative", width: "90%", maxWidth: "400px" }}>
        <div
          onClick={onClose}
          style={{
            position: "absolute",
            top: "-2%",
            right: "-2%",
            width: "15%",
            height: "10%",
            cursor: "pointer",
            zIndex: 10,
          }}
        />

        {step === 1 && (
          <>
            <img
              src={StreakPopup1}
              alt="วิธีการเล่น Streak Challenge ขั้นที่ 1"
              style={{ width: "100%", display: "block" }}
            />
            <div
              onClick={() => setStep(2)}
              style={{
                position: "absolute",
                bottom: "5%",
                right: "10%",
                width: "35%",
                height: "10%",
                cursor: "pointer",
                zIndex: 10,
              }}
            />
          </>
        )}

        {step === 2 && (
          <>
            <img
              src={StreakPopup2}
              alt="วิธีการเล่น Streak Challenge ขั้นที่ 2"
              style={{ width: "100%", display: "block" }}
            />
            <div
              onClick={() => setStep(1)}
              style={{
                position: "absolute",
                bottom: "5%",
                left: "10%",
                width: "35%",
                height: "10%",
                cursor: "pointer",
                zIndex: 10,
              }}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default StreakHowToPopup;
